import React, { useEffect, useState, useMemo } from "react";
import "./required.css";
import { useStore } from "../../store/store";
import { WrapperOver240, WrapperUnder240 } from "./Wrappers";
import { styled } from "@mui/material/styles";

const StyledSpan = styled("span")({
  color: "#4b4b4b",
});

function formatDim(size: string, sizeFraction?: string) {
  if (!sizeFraction) return size + '"';
  return `${size} ${sizeFraction}"`;
}

function RequiredDisplayBifoldCombo() {
  const material = useStore((state) => state.quote.material);
  const woodSpecies = useStore((state) => state.quote.woodSpecies);
  const doorWidth = useStore((state) => state.quote.unitSize);
  const doorWidthFraction = useStore((state) => state.quote.unitSizeFraction);
  const windowWidth = useStore((state) => state.quote.comboWindowUnitSize);
  const windowWidthFraction = useStore(
    (state) => state.quote.comboWindowUnitSizeFraction,
  );
  const doorHeight = useStore((state) => state.quote.height);
  const doorHeightFraction = useStore((state) => state.quote.heightFraction);
  const windowHeight = useStore((state) => state.quote.comboWindowHeight);
  const windowHeightFraction = useStore(
    (state) => state.quote.comboWindowHeightFraction,
  );

  const doorConfig = useStore((state) => state.quote.exactConfig);
  const windowConfig = useStore((state) => state.quote.comboWindowConfig);

  const comboUnitLeft = useStore((state) => state.quote.comboUnitLeft);
  const comboUnitRight = useStore((state) => state.quote.comboUnitRight);

  const [scrollPosition, setScrollPosition] = useState<null | number>(null);

  const listenScrollEvent = () => setScrollPosition(window.scrollY);

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  });

  const header = useMemo(() => {
    return (
      <div className="header">
        <p>
          {material ? (
            <>
              <StyledSpan>Material - </StyledSpan>
              {material}
            </>
          ) : (
            "Material"
          )}
        </p>
        <p>
          {woodSpecies ? (
            <>
              <StyledSpan>Wood - </StyledSpan>
              {woodSpecies}
            </>
          ) : (
            "Wood Species"
          )}
        </p>
        <p>
          {doorWidth || windowWidth ? (
            <>
              <StyledSpan>Width - </StyledSpan>{" "}
              {comboUnitLeft === "Door" && doorWidth
                ? `L: ${formatDim(doorWidth, doorWidthFraction)}`
                : comboUnitLeft === "Window" && windowWidth
                  ? `L: ${formatDim(windowWidth, windowWidthFraction)}`
                  : ""}
              {comboUnitRight === "Door" && doorWidth
                ? ` R: ${formatDim(doorWidth, doorWidthFraction)}`
                : comboUnitRight === "Window" && windowWidth
                  ? ` R: ${formatDim(windowWidth, windowWidthFraction)}`
                  : ""}
            </>
          ) : (
            "Width"
          )}
        </p>
        <p>
          {doorHeight || windowHeight ? (
            <>
              <StyledSpan>Height - </StyledSpan>{" "}
              {comboUnitLeft === "Door" && doorHeight
                ? `L: ${formatDim(doorHeight, doorHeightFraction)}`
                : comboUnitLeft === "Window" && windowHeight
                  ? `L: ${formatDim(windowHeight, windowHeightFraction)}`
                  : ""}
              {comboUnitRight === "Door" && doorHeight
                ? ` R: ${formatDim(doorHeight, doorHeightFraction)}`
                : comboUnitRight === "Window" && windowHeight
                  ? ` R: ${formatDim(windowHeight, windowHeightFraction)}`
                  : ""}
            </>
          ) : (
            "Height"
          )}
        </p>
        <p>
          {doorConfig || windowConfig ? (
            <>
              <StyledSpan>Configuration - </StyledSpan>
              {comboUnitLeft === "Door" ? doorConfig : windowConfig}{" "}
              {comboUnitRight === "Door" ? doorConfig : windowConfig}
            </>
          ) : (
            "Configuration"
          )}
        </p>
      </div>
    );
  }, [
    material,
    woodSpecies,
    doorWidth,
    doorWidthFraction,
    windowWidth,
    windowWidthFraction,
    doorHeight,
    doorHeightFraction,
    windowHeight,
    windowHeightFraction,
    doorConfig,
    windowConfig,
  ]);

  return (
    <>
      {scrollPosition && scrollPosition >= 240 ? (
        <WrapperOver240>{header}</WrapperOver240>
      ) : (
        <WrapperUnder240>{header}</WrapperUnder240>
      )}
    </>
  );
}

export default RequiredDisplayBifoldCombo;
